// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  text-align: center;
  display: flex;
  flex-direction: row;
  min-width: 30rem;
  min-height: 100%;
}

.app__router *:focus {
    border: none;
    outline: none;
    box-shadow: none;
}

.app__chats-panel:focus {
    border: none;
    outline: none;
    box-shadow: none;
}

.app-container .app__navmenu {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 10rem;
  height: 100%;
}

.app-container .app__chats-panel {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 8rem;
  height: 100%;
}

.app-container .app__router {
  width: calc(100% - 18rem);
  min-width: 60rem;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 10rem;
  right: 8rem;
  overflow: hidden;
}

.app__router .app__router--split-pane {
}


*::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  background: #f5f5f5;
  border-radius: 10px;
}

*::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 10px;
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border: 2px solid #f5f5f5;
}

.wmde-markdown b,
.wmde-markdown strong {
  font-weight: 600 !important;
}

.wmde-markdown ul {
  display: block;
  list-style-type: disc;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
  padding-left: 40px;
}

.wmde-markdown ol {
  display: block;
  list-style-type: decimal;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
  padding-left: 40px;
}

.wmde-markdown ul > li:not(.task-list-item) {
  list-style-type: initial !important;
}

.wmde-markdown [type="checkbox"]:not(:checked),
.wmde-markdown [type="checkbox"]:checked {
  position: initial;
  opacity: initial;
  pointer-events: initial;
}

.wmde-markdown [type="checkbox"],
.wmde-markdown [type="radio"] {
  box-sizing: initial;
  padding: initial;
}

.license-expires-dialog-container ~ div {
  height: calc(100% - 44px);
}

.main-section {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/app/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;AACA;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".app-container {\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: row;\r\n  min-width: 30rem;\r\n  min-height: 100%;\r\n}\r\n\r\n.app__router *:focus {\r\n    border: none;\r\n    outline: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.app__chats-panel:focus {\r\n    border: none;\r\n    outline: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.app-container .app__navmenu {\r\n  position: fixed;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 10rem;\r\n  height: 100%;\r\n}\r\n\r\n.app-container .app__chats-panel {\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: 8rem;\r\n  height: 100%;\r\n}\r\n\r\n.app-container .app__router {\r\n  width: calc(100% - 18rem);\r\n  min-width: 60rem;\r\n  height: 100vh;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: fixed;\r\n  left: 10rem;\r\n  right: 8rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.app__router .app__router--split-pane {\r\n}\r\n\r\n\r\n*::-webkit-scrollbar {\r\n  width: 12px;\r\n  height: 12px;\r\n}\r\n\r\n*::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);\r\n  background: #f5f5f5;\r\n  border-radius: 10px;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n  background-color: #999;\r\n  border-radius: 10px;\r\n  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);\r\n  border: 2px solid #f5f5f5;\r\n}\r\n\r\n.wmde-markdown b,\r\n.wmde-markdown strong {\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.wmde-markdown ul {\r\n  display: block;\r\n  list-style-type: disc;\r\n  margin-top: 1em;\r\n  margin-bottom: 1em;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n  padding-left: 40px;\r\n}\r\n\r\n.wmde-markdown ol {\r\n  display: block;\r\n  list-style-type: decimal;\r\n  margin-top: 1em;\r\n  margin-bottom: 1em;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n  padding-left: 40px;\r\n}\r\n\r\n.wmde-markdown ul > li:not(.task-list-item) {\r\n  list-style-type: initial !important;\r\n}\r\n\r\n.wmde-markdown [type=\"checkbox\"]:not(:checked),\r\n.wmde-markdown [type=\"checkbox\"]:checked {\r\n  position: initial;\r\n  opacity: initial;\r\n  pointer-events: initial;\r\n}\r\n\r\n.wmde-markdown [type=\"checkbox\"],\r\n.wmde-markdown [type=\"radio\"] {\r\n  box-sizing: initial;\r\n  padding: initial;\r\n}\r\n\r\n.license-expires-dialog-container ~ div {\r\n  height: calc(100% - 44px);\r\n}\r\n\r\n.main-section {\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
